"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "diagonal-lemon grid items-center rounded-l-lg px-2.5" };
const _hoisted_2 = { class: "py-4 pr-10" };
const _hoisted_3 = { class: "ocm-headline3 mb-1" };
const _hoisted_4 = ["href"];
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const CloseButton_vue_1 = __importDefault(require("@SharedVueComponents/CloseButton/CloseButton.vue"));
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const services_constants_1 = require("@ocm/services/services.constants");
const ocm_object_1 = require("@ocm/services/ocm-object");
const services_numberFormatter_1 = require("@ocm/services/services.numberFormatter");
const dataLayer_1 = __importDefault(require("@ocm/services/dataLayer"));
const CART_MIN_VALUE_DEFAULT = 100;
const TOAST_DELAY = 5 * 1000;
exports.default = (0, vue_1.defineComponent)({
    __name: 'EmarsysToast',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const cartUrl = (0, vue_3.ref)(`${ocm_object_1.shopContextPath}/cart/`);
        const _isCart = () => window.location.pathname.includes("/cart/");
        const _isPDP = () => {
            const lastSlash = window.location.pathname.lastIndexOf("/");
            const maybeProductCode = window.location.pathname.substring(lastSlash - 9, lastSlash);
            return maybeProductCode.length && !Number.isNaN(+maybeProductCode);
        };
        // Tracking
        const trackGA3Toast = (action) => {
            var _a, _b, _c, _d;
            const pagePath = (_d = (_c = (_b = (_a = window.recommendationData) === null || _a === void 0 ? void 0 : _a.Recommendation) === null || _b === void 0 ? void 0 : _b.pageData) === null || _c === void 0 ? void 0 : _c.pagePath) !== null && _d !== void 0 ? _d : "";
            (0, dataLayer_1.default)({
                event: "GAevent",
                event_category: "S_jetztSparenLayer",
                event_action: action,
                event_label: pagePath,
            });
        };
        const routeToCart = () => {
            if (_isCart())
                return;
            trackGA3Toast("S_cart");
            window.ocmOrchestrator ? window.ocmOrchestrator.spaNavigateUrl(cartUrl.value) : window.location.assign(cartUrl.value);
        };
        const hasToast = (0, vue_3.ref)(false);
        const removeToast = () => {
            hasToast.value = false;
        };
        const isToastVisible = (0, vue_3.ref)(true);
        const _setIsToastVisible = (val) => {
            isToastVisible.value = val;
        };
        const savingTotal = (0, vue_3.ref)("");
        (0, vue_3.watch)(savingTotal, (val) => {
            if (!val)
                removeToast();
        });
        let _delayTimeout;
        const _setupToast = (cartMinValue = CART_MIN_VALUE_DEFAULT) => {
            if (sessionStorage.getItem("cartToastShown"))
                return;
            clearTimeout(_delayTimeout);
            _delayTimeout = setTimeout(() => {
                var _a, _b, _c, _d;
                const cartData = (_c = (_b = (_a = window.recommendationData) === null || _a === void 0 ? void 0 : _a.Recommendation) === null || _b === void 0 ? void 0 : _b.customerData) === null || _c === void 0 ? void 0 : _c.cart;
                // abbrechen, wenn der Warenkorb leer ist oder sein Gesamtwert einen definierten Mindestwert unterschreitet
                if (!((_d = cartData === null || cartData === void 0 ? void 0 : cartData.products) === null || _d === void 0 ? void 0 : _d.length) || +cartData.cartTotal < cartMinValue)
                    return;
                if (!savingTotal.value) {
                    const saving = cartData.products.reduce((acc, { msrp, price, quantity }) => acc + (+msrp - +price) * +quantity, 0);
                    savingTotal.value = (0, services_numberFormatter_1.formatPrice)(saving, cartData.currency);
                }
                if (_isCart() || _isPDP())
                    _setIsToastVisible(false);
                hasToast.value = true;
                trackGA3Toast("S_show");
                try {
                    sessionStorage.setItem("cartToastShown", "1");
                }
                catch (error) {
                    console.error(error);
                }
            }, TOAST_DELAY);
        };
        (0, vue_3.onMounted)(() => {
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.UPDATED_CART_SAVING, ({ data }) => {
                savingTotal.value = data;
            });
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.ADD_EMARSYS_TOAST, ({ data }) => {
                _setupToast(data === null || data === void 0 ? void 0 : data.cartMinValue);
            });
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.ROUTE_CHANGE_MOUNTED_APPS, ({ data: { mountedApps } }) => {
                _setIsToastVisible(!mountedApps.includes("mf-cart") && !_isPDP());
            });
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.ENTER_PRODUCTDETAIL, () => {
                _setIsToastVisible(false);
            });
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.LEAVE_PRODUCTDETAIL, () => {
                _setIsToastVisible(true);
            });
        });
        (0, vue_3.onBeforeUnmount)(() => {
            clearTimeout(_delayTimeout);
            removeToast();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#emarsys-toast-container" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "emarsys-toast" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (hasToast.value && isToastVisible.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "emarsys-toast ocm-body1 pointer-events-auto relative mb-2 grid min-h-5 max-w-96 grid-cols-[4.8571428571rem,1fr] justify-self-center rounded-lg bg-gray-beton focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-current",
                                tabindex: "-1",
                                onClick: _cache[2] || (_cache[2] = ($event) => {
                                    removeToast();
                                    routeToCart();
                                })
                            }, [
                                (0, vue_2.createVNode)(CloseButton_vue_1.default, {
                                    class: "close-button right-0 top-1 border-transparent",
                                    inverted: "",
                                    "aria-label": (0, vue_2.unref)(t)('siteWide.emarsysToast.closeMessage'),
                                    onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => {
                                        removeToast();
                                        trackGA3Toast('S_closeX');
                                    }, ["stop"]))
                                }, null, 8, ["aria-label"]),
                                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                        class: "size-7",
                                        "icon-name": "circle-percent"
                                    })
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.emarsysToast.youSave", { amount: savingTotal.value })), 1),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.emarsysToast.onItems")) + " ", 1),
                                        (0, vue_2.createElementVNode)("a", {
                                            href: cartUrl.value,
                                            class: "inline-block underline after:inline-block after:whitespace-pre after:content-['_'] last:after:content-none hover:text-gray-90",
                                            onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(() => { }, ["prevent"]))
                                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.emarsysToast.inYourCart")), 9, _hoisted_4)
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
